import React, { createContext, useContext, useEffect } from "react";
import { ShowCardsType } from "../../services/CardServices";
import { useAuth } from "../AuthProvider";
import {
  UsePaginatedDataResult,
  usePaginatedData,
} from "../helper/usePaginatedData";
import { getCollectorCards } from "../../services/CollectorServices";

interface CollectorCardsContextProps {
  cardsState: UsePaginatedDataResult<ShowCardsType>;
}

const CollectorCardsContext = createContext<
  CollectorCardsContextProps | undefined
>(undefined);

export const CollectorCardsProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const cardsState = usePaginatedData<ShowCardsType>();
  const { user } = useAuth();
  const limit = 16;

  useEffect(() => {
    if (user && cardsState.page > 0)
      cardsState.fetchData(limit, getCollectorCards);

    // only rerun on page change ...
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardsState.page]);

  useEffect(() => {
    cardsState.setPage(0);
    cardsState.setHasMore(true);
    cardsState.setFilteredData([]);
    cardsState.setData([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <CollectorCardsContext.Provider
      value={{
        cardsState,
      }}
    >
      {children}
    </CollectorCardsContext.Provider>
  );
};

export const useCollectorCardsContext = () => {
  const context = useContext(CollectorCardsContext);
  if (!context) {
    throw new Error(
      "useCollectorCardsContext must be used within a CollectorCardsProvider"
    );
  }
  return context;
};
